export const getters = {
  // Get all reports for an organization (sorted by newest first)
  getOrgReports: (state) => (orgId) => {
    const reports = Object.values(state.reports[orgId] || {})
    // Sort by created_at descending (newest first)
    return reports.sort((a, b) => {
      const dateA = new Date(a.created_at)
      const dateB = new Date(b.created_at)
      return dateB - dateA
    })
  },

  // Get a specific report
  getReport: (state) => (orgId, reportUuid) => {
    return state.reports[orgId]?.[reportUuid] || null
  },

  // Get active report
  getActiveReport: (state) => {
    if (!state.activeReportUuid) return null

    // Find the report in any org
    for (const orgId in state.reports) {
      const report = state.reports[orgId][state.activeReportUuid]
      if (report) return report
    }
    return null
  },

  // Get active report UUID
  getActiveReportUuid: (state) => {
    return state.activeReportUuid
  },

  // Get active version
  getActiveVersion: (state) => {
    return state.activeVersion
  }
}
